export const FormControlTypes = {
  CHECKBOX: 'checkbox',
  CURRENCY: 'currency',
  DATE: 'date',
  DEFAULT: 'text',
  IBAN: 'iban',
  NUMBER: 'number',
  PASSWORD: 'password',
  RADIO: 'radio',
  SEARCH: 'search',
  SELECT: 'select',
  SUGGEST: 'suggest',
  TEXT: 'text',
  TEXTAREA: 'textarea',
  TEXTLIST: 'textlist',
  TOGGLE: 'toggle',
  UPLOAD: 'uploadFile'
}

export const NoLabelTypes = [
  'radio',
  'checkbox',
  'uploadFile'
]

export const IbanDisplayMode = {
  IBAN: 'iban',
  BCAN: 'bcan' // bank code + account number
}
